import React from 'react';
import { HeaderGroup, TableInstance } from 'react-table';

interface UniversalTableHeaderProps {
  table: TableInstance<any>;
  showFilters?: boolean;
}

const UniversalTableHeader: React.FC<UniversalTableHeaderProps> = ({
  table,
  showFilters = false,
}) => {
  const { headerGroups, setFilters } = table;

  return (
    <thead className="bg-gray-100 dark:bg-gray-800">
      {headerGroups.map((headerGroup: HeaderGroup<any>) => {
        // ✅ extraemos key y esparcimos el resto
        const { key: groupKey, ...groupRest } = headerGroup.getHeaderGroupProps();

        return (
          <React.Fragment key={headerGroup.id}>
            <tr key={`${headerGroup.id}-headers`} {...groupRest}>
              {headerGroup.headers.map((column) => {
                const { key: colKey, ...colRest } = column.getHeaderProps(
                  column.getSortByToggleProps?.()
                );

                return (
                  <th
                    key={colKey}
                    {...colRest}
                    className="px-5 py-4 text-left text-sm font-semibold text-gray-800 dark:text-gray-200 sm:text-base"
                  >
                    <div className="flex items-center">
                      {column.render('Header')}
                      <div className="ml-2 inline-flex flex-col space-y-[2px]">
                        <span className="inline-block">
                          <svg
                            className="fill-current"
                            width="10"
                            height="5"
                            viewBox="0 0 10 5"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M5 0L0 5H10L5 0Z" />
                          </svg>
                        </span>
                        <span className="inline-block">
                          <svg
                            className="fill-current"
                            width="10"
                            height="5"
                            viewBox="0 0 10 5"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M5 5L10 0L0 0L5 5Z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </th>
                );
              })}
            </tr>

            {/* ✅ Segunda fila (filtros) también necesita keys */}
            {showFilters && (
              <tr key={`${headerGroup.id}-filters`}>
                {headerGroup.headers.map((column) => (
                  <th key={`${column.id}-filter`} className="px-4 py-2">
                    <input
                      type="text"
                      placeholder="Buscar..."
                      className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent py-2.5 px-4 text-black outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                      onChange={(e) =>
                        setFilters((prev: any) => ({
                          ...prev,
                          [column.id]: e.target.value,
                        }))
                      }
                    />
                  </th>
                ))}
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </thead>
  );
};

export default UniversalTableHeader;
